module.exports = __webpack_public_path__ + "static/miss-monique_0-c47dea221d5054228fa3ee067917f6c4.jpg";